<app-alert></app-alert>
<section class="panel panel-default">

    <div class="card-header">
        <title>MBP-3  Register of Investment not held in its own name by the company</title>
        <span class="cat__core__title">
            <strong id="pageTitle">MBP-3  Register of Investment not held in its own name by the company</strong>
        </span>

        <span style="float: right">
            <!-- <a routerLink="/mbp3List"> -->
                <button (click)="back()"  class="btn btn-sm btn-default pull-right btn-back" type="button">
                    <i class=" fa fa-chevron-circle-left"></i>
                    Back
                </button>
            <!-- </a> -->
        </span>
        <!-- <span style="float:right">
                <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button"  *ngIf="!addBtn">
                  <span>
                    <i class="fa fa-save"></i>Generate Output </span>
                </button>
        </span> -->
       
    </div>

   
        <form [formGroup]="mbp3Form" (document:click)="a.close();b.close();c.close()">
                <div class="modal-body">
            <div class="row">
                
                <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Date of the board resolution authorizing such investment<span
                        _ngcontent-c2="" style="color: red;">*</span></label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="mbp3Form.controls['dateOfBoardResolution']"
                        [(ngModel)]="dateOfBoardResolutionModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="titledate"
                        ngbDatepicker #a="ngbDatepicker" (click)="a.toggle()">
                      <button class="input-group-addon" (click)="a.toggle()" type="button">
                        <span class="fa fa-calendar"style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                      </button>
                    </div>
                    <div *ngIf="mbp3Form.controls['dateOfBoardResolution'].hasError('required') && mbp3Form.controls['dateOfBoardResolution'].touched"
                    class="form-control-error-custom">
                    Date of the board resolution authorizing such investment is required
                </div>
             </div>

                
                <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
                    <label>Date of investment</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="mbp3Form.controls['dateOfInvestment']"
                        [(ngModel)]="dateOfInvestmentModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="titledate"
                        ngbDatepicker #b="ngbDatepicker" (click)="b.toggle()">
                      <button class="input-group-addon" (click)="b.toggle()" type="button">
                        <span class="fa fa-calendar"style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                      </button>
                    </div>
             </div>

                <div class=" form-group col-md-4 col-sm-6 col-xs-12"><br>
                    <label>Investment held by </label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <select class="form-control" [formControl]="mbp3Form.controls['investmentHeldBy']"
                        style="padding:6px;" required="required">
                        <option value="" [selected]="true">Select</option>
                        <option value="Person">Person</option>
                        <option value="Depository">Depository</option>
                    </select>
                    <div *ngIf="mbp3Form.controls['investmentHeldBy'].hasError('required') && mbp3Form.controls['investmentHeldBy'].touched"
                        class="form-control-error-custom">
                        Investment held by is required
                    </div>
                </div>
            </div>

            <div class="row">

                <div class="col-md-4 col-sm-6 col-xs-12"><br>
                    <label class="form-control-label">Type of investment held </label>
                    <div class="form-group">
                        <input type="text" [formControl]="mbp3Form.controls['typeOfInvestment']" class="form-control">
                    </div>
                </div>

                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Name of the Person / depository in whose name investment is
                        held</label>
                    <div class="form-group">
                        <input type="text" [formControl]="mbp3Form.controls['nameOfThePersonInvestment']"
                            class="form-control">
                        <div *ngIf="(mbp3Form.controls['nameOfThePersonInvestment'].hasError('pattern') || mbp3Form.controls['nameOfThePersonInvestment'].hasError('maxlength')) && mbp3Form.controls['nameOfThePersonInvestment'].touched"
                            class="form-control-error-custom">
                            Name of the Person / depository is invalid
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Address of person / depository in whose name investment is
                        held</label>
                    <div class="form-group">
                        <input type="text" [formControl]="mbp3Form.controls['addressOfPerson']"
                            class="form-control">
                        <div *ngIf="(mbp3Form.controls['addressOfPerson'].hasError('pattern') || mbp3Form.controls['addressOfPerson'].hasError('maxlength')) && mbp3Form.controls['addressOfPerson'].touched"
                            class="form-control-error-custom">
                            Address of person / depository is invalid
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">

                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">E-mail id of person / depository in whose name investment is
                        held</label>
                    <div class="form-group">
                        <input type="email" [formControl]="mbp3Form.controls['emailOfPerson']" class="form-control">
                        <div *ngIf="(mbp3Form.controls['emailOfPerson'].hasError('pattern') || mbp3Form.controls['emailOfPerson'].hasError('maxlength')) && mbp3Form.controls['emailOfPerson'].touched"
                            class="form-control-error-custom">
                            E-mail id is invalid
                        </div>

                    </div>
                </div>

                <div class="col-md-4 col-sm-6 col-xs-12"><br>
                    <label class="form-control-label"> Purpose of investment</label>
                    <div class="form-group">
                        <input type="text" [formControl]="mbp3Form.controls['purposeOfInvestment']"
                            class="form-control">
                        <div *ngIf="(mbp3Form.controls['purposeOfInvestment'].hasError('pattern') || mbp3Form.controls['purposeOfInvestment'].hasError('maxlength')) && mbp3Form.controls['purposeOfInvestment'].touched"
                            class="form-control-error-custom">
                            Purpose of investment is invalid
                        </div>
                    </div>
                </div>


                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Name of the company or body corporate in which investment is
                        made</label>
                    <div class="form-group">
                        <input type="text" [formControl]="mbp3Form.controls['nameOfCompany']" class="form-control">
                        <div *ngIf="(mbp3Form.controls['nameOfCompany'].hasError('pattern') || mbp3Form.controls['nameOfCompany'].hasError('maxlength')) && mbp3Form.controls['nameOfCompany'].touched"
                            class="form-control-error-custom">
                            Name of the company is invalid
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">

                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Class of securities </label>
                    <div class="form-group">
                        <input type="text" [formControl]="mbp3Form.controls['classOfSecurities']" class="form-control">
                        <div *ngIf="(mbp3Form.controls['classOfSecurities'].hasError('pattern') || mbp3Form.controls['classOfSecurities'].hasError('maxlength')) && mbp3Form.controls['classOfSecurities'].touched"
                            class="form-control-error-custom">
                            Class of securities is invalid
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Number of securities</label>
                    <div class="form-group">
                        <input [formControl]="mbp3Form.controls['numberOfSecurities']" (keydown)="onlyNumber($event)"
                            class="form-control">
                        <div *ngIf="(mbp3Form.controls['numberOfSecurities'].hasError('pattern') || mbp3Form.controls['numberOfSecurities'].hasError('maxlength')) && mbp3Form.controls['numberOfSecurities'].touched"
                            class="form-control-error-custom">
                            Number of securities is invalid
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Client ID / DP No. </label>
                    <div class="form-group">
                        <input [formControl]="mbp3Form.controls['clientId']" class="form-control">
                        <div *ngIf="(mbp3Form.controls['clientId'].hasError('pattern') || mbp3Form.controls['clientId'].hasError('maxlength')) && mbp3Form.controls['clientId'].touched"
                            class="form-control-error-custom">
                            Client ID / DP No. is invalid
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Face value of securities </label>
                    <div class="form-group">
                        <input [formControl]="mbp3Form.controls['faceValueOfSecurities']" class="form-control">
                        <div *ngIf="(mbp3Form.controls['faceValueOfSecurities'].hasError('pattern') || mbp3Form.controls['faceValueOfSecurities'].hasError('maxlength')) && mbp3Form.controls['faceValueOfSecurities'].touched"
                            class="form-control-error-custom">
                            Face value of securities is invalid
                        </div>
                    </div>

                </div>

                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Paid up value of securities </label>
                    <div class="form-group">
                        <input [formControl]="mbp3Form.controls['paidUpValueOfSecurities']" class="form-control">
                        <div *ngIf="(mbp3Form.controls['paidUpValueOfSecurities'].hasError('pattern') || mbp3Form.controls['paidUpValueOfSecurities'].hasError('maxlength')) && mbp3Form.controls['paidUpValueOfSecurities'].touched"
                            class="form-control-error-custom">
                            Paid up value of securities is invalid
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Cost of acquisition</label>
                    <div class="form-group">
                        <input [formControl]="mbp3Form.controls['costOfAcquistion']" class="form-control" >
                        <div *ngIf="(mbp3Form.controls['costOfAcquistion'].hasError('pattern') || mbp3Form.controls['costOfAcquistion'].hasError('maxlength')) && mbp3Form.controls['costOfAcquistion'].touched"
                            class="form-control-error-custom">
                            Cost of acquisition is invalid
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
<!-- 
                <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-group">Date of disposal </label>
                    <div class="input-group">
                        <input class="form-control" [formControl]="mbp3Form.controls['dateofdisposal']"
                            [(ngModel)]="dateofdisposalModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                            ngbDatepicker #c="ngbDatepicker" (click)="c.toggle()">
                        <button class="input-group-addon" (click)="c.toggle()" type="button">
                            <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                        </button>
                    </div>
                </div> -->

                <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Date of disposal </label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="mbp3Form.controls['dateofdisposal']"
                        [(ngModel)]="dateofdisposalModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="titledate"
                        ngbDatepicker #c="ngbDatepicker" (click)="c.toggle()">
                      <button class="input-group-addon" (click)="c.toggle()" type="button">
                        <span class="fa fa-calendar"style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                      </button>
                    </div>
             </div>

                   


                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Number of securities disposed of</label>
                    <div class="form-group">
                        <input [formControl]="mbp3Form.controls['numberOfSecuritiesDisposedOff']" class="form-control" >

                        <div *ngIf="(mbp3Form.controls['numberOfSecuritiesDisposedOff'].hasError('pattern') || mbp3Form.controls['numberOfSecuritiesDisposedOff'].hasError('maxlength')) && mbp3Form.controls['numberOfSecuritiesDisposedOff'].touched"
                            class="form-control-error-custom">
                            Number of securities disposed of is invalid
                        </div>
                    </div>

                </div>

                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Sale consideration </label>
                    <div class="form-group">
                        <input [formControl]="mbp3Form.controls['saleConsideration']" class="form-control" >
                        <div *ngIf="(mbp3Form.controls['saleConsideration'].hasError('pattern') || mbp3Form.controls['saleConsideration'].hasError('maxlength')) && mbp3Form.controls['saleConsideration'].touched"
                            class="form-control-error-custom">
                            Sale consideration is invalid
                        </div>

                    </div>
                </div>
            </div>

            <div class="row">

                <div class="col-md-4 col-sm-6 col-xs-12">
                    <br><label class="form-control-label">Balance securities left, if any</label>
                    <div class="form-group">
                        <input [formControl]="mbp3Form.controls['balanceSecuritiesLeft']" class="form-control" >
                        <div *ngIf="(mbp3Form.controls['balanceSecuritiesLeft'].hasError('pattern') || mbp3Form.controls['balanceSecuritiesLeft'].hasError('maxlength')) && mbp3Form.controls['balanceSecuritiesLeft'].touched"
                            class="form-control-error-custom">
                            Balance securities left is invalid
                        </div>

                    </div>
                </div>

                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">The relationship or contract under which the investment is held in
                        the name of any other person</label>
                    <div class="form-group">
                        <input type="text" [formControl]="mbp3Form.controls['theRelationshipContract']"
                            class="form-control">
                        <div *ngIf="(mbp3Form.controls['theRelationshipContract'].hasError('pattern') || mbp3Form.controls['theRelationshipContract'].hasError('maxlength')) && mbp3Form.controls['theRelationshipContract'].touched"
                            class="form-control-error-custom">
                            The relationship or contract is invalid
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-sm-6 col-xs-12"><br>
                    <label class="form-control-label">Reasons for not holding the investments in its own name</label>
                    <div class="form-group">
                        <textarea [formControl]="mbp3Form.controls['reasonsForNotHolding']"
                            class="form-control"></textarea>
                        <div *ngIf="(mbp3Form.controls['reasonsForNotHolding'].hasError('pattern') || mbp3Form.controls['reasonsForNotHolding'].hasError('maxlength')) && mbp3Form.controls['reasonsForNotHolding'].touched"
                            class="form-control-error-custom">
                            Reasons for not holding the investments in its own name is invalid
                        </div>
                    </div>
                </div>

                <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Remarks, if any</label>
                    <textarea class="form-control" [formControl]="mbp3Form.controls['remarks']"
                        maxlength="250"> </textarea>
                    <div *ngIf="(mbp3Form.controls['remarks'].hasError('pattern') || mbp3Form.controls['remarks'].hasError('maxlength')) && mbp3Form.controls['remarks'].touched"
                        class="form-control-error-custom">
                        Remarks is invalid
                    </div>
                </div>
            </div>
        </div>
            <div class="card-footer" align="right">
                <button class="btn btn-sm btn-primary" (click)="saveMbp3Data('add')" [disabled]="!mbp3Form.valid || disabledOnClick" type="button"
                    *ngIf="addBtn">&nbsp;Save</button>
                <button class="btn btn-sm btn-primary" (click)="saveMbp3Data('update')" [disabled]="!mbp3Form.valid || disabledOnClick" type="button"
                    *ngIf="!addBtn">&nbsp;Update</button>
            </div>

        </form>
    

</section>